import React from 'react'
import { SvgProps } from 'src/shared/types/svg-props-type'

export const XCircleFill02Icon = (props?: SvgProps) => (
  <svg
    width="36"
    height="36"
    viewBox="0 0 36 36"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>{props?.title}</title>
    <g clipPath="url(#clip0_15766_60986)">
      <path
        d="M18 36C27.9411 36 36 27.9411 36 18C36 8.05887 27.9411 0 18 0C8.05887 0 0 8.05887 0 18C0 27.9411 8.05887 36 18 36Z"
        fill="#DFF1FD"
        fillOpacity="0.6"
      />
      <path
        d="M21.7807 13.2092C22.0597 12.9303 22.5118 12.9303 22.7908 13.2092C23.0697 13.4882 23.0697 13.9403 22.7908 14.2193L19.0101 18L22.7908 21.7807L22.8396 21.8351C23.0684 22.1157 23.0523 22.5293 22.7908 22.7908C22.5293 23.0523 22.1157 23.0684 21.8351 22.8396L21.7807 22.7908L18 19.0101L14.2193 22.7908C13.9403 23.0697 13.4882 23.0697 13.2092 22.7908C12.9303 22.5118 12.9303 22.0597 13.2092 21.7807L16.9899 18L13.2092 14.2193C12.9303 13.9403 12.9303 13.4882 13.2092 13.2092C13.4882 12.9303 13.9403 12.9303 14.2193 13.2092L18 16.9899L21.7807 13.2092Z"
        fill="#0286CA"
      />
    </g>
    <defs>
      <clipPath id="clip0_15766_60986">
        <rect width="36" height="36" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
